import type { MaybeRefOrGetter } from 'vue';

import { computed, toValue } from 'vue';

import { operationLocationContext } from '@/shared/api';

import { useAuthStore } from '../model/auth-store';

/** Контекст Apollo-операций записи: заголовок её локации, если она не текущая во вкладке. */
export function useRecordOperationContext(locationId: MaybeRefOrGetter<string | null | undefined>) {
  const auth = useAuthStore();
  const isForeign = computed(() => {
    const id = toValue(locationId);

    return Boolean(id) && id !== auth.currentLocation?.id;
  });
  const context = computed(() => (isForeign.value ? operationLocationContext(toValue(locationId)) : {}));

  return { isForeign, context };
}

export type UseRecordOperationContextReturn = ReturnType<typeof useRecordOperationContext>;
